import { StyleSheet, View } from 'react-native';
import { colors } from '../../theme/colors';
import { tokens } from '../../theme/tokens';
import { fieldFontFamily } from '../../theme/typography';

interface DatePickerInputProps {
  value: string;
  onChange: (dateString: string) => void;
  placeholder?: string;
  accessibilityLabel?: string;
  testID?: string;
}

export function DatePickerInput({
  value,
  onChange,
  placeholder,
  accessibilityLabel,
  testID,
}: DatePickerInputProps) {
  return (
    <View style={styles.container}>
      <input
        data-testid={testID}
        aria-label={accessibilityLabel ?? placeholder}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          border: 'none',
          background: 'transparent',
          color: value ? colors.text.primary : colors.text.tertiary,
          fontSize: tokens.fontSize.base,
          fontFamily: fieldFontFamily,
          outline: 'none',
          width: '100%',
          height: 42,
          padding: 0,
          margin: 0,
          cursor: 'pointer',
          colorScheme: 'dark',
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: tokens.radius.md,
    borderWidth: 1,
    borderColor: colors.border.input,
    backgroundColor: colors.background.input,
    paddingHorizontal: tokens.spacing.sm,
    height: 44,
    justifyContent: 'center',
    minWidth: 130,
    maxWidth: 190,
  },
});
